import type { CSSObject } from '@mantine/core';
import { createStyles } from '@mantine/core';

interface LineageFlowStylesProps {
	isFullscreen: boolean;
}

export const useStyles = createStyles(
	(theme, { isFullscreen }: LineageFlowStylesProps) => ({
		wrapper: {
			position: 'relative',
			width: '100%',
			height: '100%',
			gap: theme.spacing.md,
			padding: isFullscreen ? theme.spacing.md : 0,
		},
		reactFlow: {
			backgroundColor: `${theme.other.getColor('surface/tertiary/default')} !important`,
			borderRadius: theme.radius.md,
			'.react-flow__handle': {
				width: theme.other.space[2],
				height: theme.other.space[2],
				backgroundColor: theme.other.getColor('border/emphasis/default'),
				pointerEvents: 'all !important' as CSSObject['pointerEvents'],
				'&:hover': {
					backgroundColor: `${theme.other.getColor('fill/primary/default')} !important`,
					outlineColor: `${theme.other.getColor('border/emphasis/default')} !important`,
					outlineWidth: '2px !important' as CSSObject['borderWidth'],
					outlineStyle: 'solid !important' as CSSObject['borderStyle'],
					'&:before, &:after': {
						content: '""',
						position: 'absolute',
						backgroundColor: theme.other.getColor('text/emphasis/default'),
						borderRadius: theme.radius.xl,
					},
					'&:before': {
						width: '6px !important' as CSSObject['width'],
						height: '2px !important' as CSSObject['height'],
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
					},
					'&:after': {
						width: '2px !important' as CSSObject['width'],
						height: '6px !important' as CSSObject['height'],
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
					},
				},
			},
			'.react-flow__minimap': {
				border: `${theme.other.space[0.25]} solid ${theme.other.getColor('border/secondary/default')}`,
				borderRadius: theme.radius.md,
				boxShadow: theme.shadows.md,
				overflow: 'hidden',
			},
			'.react-flow__attribution': {
				display: 'none',
			},
		},
	})
);
